import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { IServiceAccountsState } from ".";
import { ServiceAccountsMutationsNames } from "./enums";
import { IServiceAccount } from "@/models/serviceaccount";

export const actions: ActionTree<IServiceAccountsState, IRootState> = {
    fetchScopedSAList({ commit }, uuidSP: string): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "scopedserviceaccounts"
                ),
                {
                    params: {
                        serviceProviderUuid: uuidSP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage sa scoped list
                    commit(
                        ServiceAccountsMutationsNames.SetScopedSAList,
                        response.data
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(ServiceAccountsMutationsNames.SetScopedSAError, error);
            });
    },
    fetchUnscopedSAList({ commit }): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "unscopedserviceaccounts"
                ),
                {
                    params: {},
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage sa unscoped list
                    commit(
                        ServiceAccountsMutationsNames.SetUnscopedSAList,
                        response.data
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(ServiceAccountsMutationsNames.SetUnscopedSAError, error);
            });
    },
    setSelectedServiceAccount(
        this,
        { commit },
        serviceAccount: IServiceAccount
    ) {
        commit(ServiceAccountsMutationsNames.SetSelected, serviceAccount);
    },
    resetServiceAccountState({ commit }): void {
        commit(ServiceAccountsMutationsNames.ResetState);
    },
};
